import { useQuery } from '@tanstack/react-query';
import { fetchPatientPermissions } from '../services/care_plan';
import { getActiveRole } from '../utils/permissions';

const usePatientPermissions = () => {
  const patientId = localStorage.getItem('patient');
  const activeRole = getActiveRole();
  const isClinicalLocationAdmin = activeRole === 'CLINICAL_LOCATION_ADMIN';

  return useQuery({
    queryKey: ['patientPermissions', patientId],
    queryFn: async () => {
      const result = await fetchPatientPermissions();
      if (result?.data) {
        localStorage.setItem('patientPermissions', JSON.stringify(result.data));
      }
      return result;
    },
    enabled: !!patientId && !isClinicalLocationAdmin,
    staleTime: 0,
    refetchOnMount: true,
  });
};

export default usePatientPermissions;
